import { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
// import useAxios from 'axios-hooks';
import axios from 'axios';

// dynamically load CSS on to the page
const useCss = media => {
  const dataUrl = useSelector(state => state.BlockState.dataUrl, shallowEqual);
  const [cssloaded, setCssLoaded] = useState(false);
  const isRTL =
    document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl'
      ? true
      : false;

  useEffect(() => {
    const handleCss = async () => {
      // style tag in dom
      const styleTag = document.getElementById(`stylesheet-${media.id}`);
      // if stylesheet
      if (media.stylesheet && !styleTag) {
        const { data: css } = await axios(
          `${dataUrl}assets/${media.stylesheet}.css`
        );

        let styleTag = document.createElement('style');
        let cssUpdate = css;
        if (media.type === 'svg' || media.subtype === 'svg') {
          // remove any occurences of svg when followed by .dynamic-text-item
          // since we're no longer placing text inside the SVG
          cssUpdate = css.replace(
            /svg \.dynamic-text-item/g,
            '.dynamic-text-item'
          );
          cssUpdate = cssUpdate.replace(/ x:/g, ' left: ');
          cssUpdate = cssUpdate.replace(/ y:/g, ' top: ');
          // swap any hard-coded text alignment from left to right for RTL languages
          if (isRTL) {
            cssUpdate = cssUpdate
              .replace(/text-align: left/g, 'text-align: right')
              .replace(/text-align:left/g, 'text-align: right');
          }
        }
        // add id to style tag
        styleTag.id = `stylesheet-${media.id}`;
        // add the css as text
        styleTag.appendChild(document.createTextNode(cssUpdate));
        // add to head
        document.head.appendChild(styleTag);
        // locked and loaded
        setCssLoaded(true);
      } else {
        // if not, set true
        setCssLoaded(true);
      }
    };
    handleCss();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // return loaded true/false
  return cssloaded;
};
export default useCss;
